import { Injectable } from '@angular/core';
import { _Service } from './_service';
import { AppId, LegalNorm, LegalNormArticle, LegalNormListItem } from '../../model';

@Injectable({ providedIn: 'root' })
export class LegalNormService extends _Service<LegalNorm> {
  constructor() {
    super('api/legal-norm');
  }

  listAll = async () => this.http.get<LegalNormListItem[]>('api/legal-norm');
  detailArticle = async (legalNorm: AppId, article: AppId) =>
    this.http.get<LegalNormArticle>(`api/legal-norm/${legalNorm}/${article}`);
  deleteArticle = async (legalNorm: AppId, article: AppId) =>
    this.http.delete<LegalNormArticle>(`api/legal-norm/${legalNorm}/${article}`);
  createArticle = async (legalNorm: AppId, data: LegalNormArticle) =>
    this.http.post<LegalNormArticle>(`api/legal-norm/${legalNorm}`, data);
  updateArticle = async (legalNorm: AppId, article: AppId, data: LegalNormArticle) =>
    this.http.put<LegalNormArticle>(`api/legal-norm/${legalNorm}/${article}`, data);
}
